"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addVariable = addVariable;
exports.clearVariables = clearVariables;
exports.cloneVariables = cloneVariables;
exports.getVariable = getVariable;
exports.getVariables = getVariables;
exports.hasVariable = hasVariable;
exports.removeSingleBeaconVariables = removeSingleBeaconVariables;
exports.removeVariable = removeVariable;

var _getKeys = _interopRequireDefault(require("./utilities/getKeys"));

var variables = {};
var singleBeaconVariables = [];

function addVariable(key, value) {
  var singleBeacon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (value != null) {
    variables[key] = value;

    if (singleBeacon) {
      singleBeaconVariables.push(key);
    }
  }
}

function getVariable(key) {
  return variables[key];
}

function getVariables() {
  return variables;
}

function cloneVariables() {
  var clone = {};
  (0, _getKeys.default)(variables).forEach(function (key) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    clone[key] = variables[key];
  });
  return clone;
}

function hasVariable(key) {
  return variables[key] != null;
}

function removeVariable(key) {
  delete variables[key];
}

function clearVariables() {
  variables = {};
}

function removeSingleBeaconVariables() {
  singleBeaconVariables.forEach(removeVariable);
  singleBeaconVariables = [];
}